
//import { TestItem } from "../../ts/model";

export default {
  props: ["questions"],
  data() {
    return {
      showNotAnsweredQuestions: false,
      items: [],
    };
  },
  watch: {
    showNotAnsweredQuestions: function (val) {
      setTimeout(() => {
        console.log("showNotAnsweredQuestions", val);
        this.scrollToAnchor("showNotAnsweredQuestions");
      }, "100");
    },
  },
  mounted() {
    this.items = this.questions;
  },
  methods: {
    selectOption: function (id, optionId) {
      this.items[id - 1].selected = optionId;
      this.$emit("update:questions", this.items);
    },
    //TODO Вынести в общую библотеку
    scrollToAnchor: function (anchorId) {
      const headerHeight = document.getElementById("header").offsetHeight;
      let element = document.getElementById(anchorId);
      if (element) {
        // Вычисляем позицию отступа наверху элемента
        let offset = 0;
        while (element) {
          offset += element.offsetTop - element.scrollTop + element.clientTop;
          element = element.offsetParent;
        }
        // Выполняем плавную прокрутку к якорю
        window.scrollTo({
          top: offset - 200,
          behavior: "smooth",
        });
      }
    },
  },
  computed: {
    showItems: function () {
      if (!this.showNotAnsweredQuestions) {
        return this.items;
      } else {
        const res = [];
        this.items.forEach((item) => {
          if (this.showNotAnsweredQuestions && item.selected == -1) {
            res.push(item);
          }
        });
        return res;
      }
    },
    lenght: function () {
      return this.items.length;
    },
  },
};
